module.exports = __webpack_public_path__ + "static/media/tab_2.00e5d3af.png";